import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/chat'
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/LoginView.vue'),
      meta: {
        title: '登录',
        guestOnly: true
      }
    },
    {
      path: '/chat',
      name: 'Chat',
      component: () => import('@/views/ChatView.vue'),
      meta: {
        title: '智能助手对话',
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach(async (to, _from, next) => {
  document.title = (to.meta.title as string) || '独立对话窗口'

  const token = localStorage.getItem('token') || sessionStorage.getItem('token')
  const isAuthenticated = !!token

  if (to.meta.requiresAuth && !isAuthenticated) {
    next({
      name: 'Login',
      query: { redirect: to.fullPath || '/chat' }
    })
    return
  }

  if (to.meta.guestOnly && isAuthenticated) {
    const redirect = typeof to.query.redirect === 'string' && to.query.redirect
      ? to.query.redirect
      : '/chat'
    next(redirect)
    return
  }

  next()
})

export default router
